// extracted by mini-css-extract-plugin
export default {"container":"ClientKanbanItem_container__R0u7S","title":"ClientKanbanItem_title__IjDp1","value":"ClientKanbanItem_value__4sOIC","icon":"ClientKanbanItem_icon__Rj5yh"};